import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[dbScrollOnDrag]',
    standalone: false
})
export class ScrollOnDragDirective {
  @Input() drake: any;

  private _pageY: number;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('document:mousemove', ['$event'])
  private _onMouseMove(e: MouseEvent): void {
    this._pageY = e.pageY;

    if (this.drake.dragging) {
      const y = this._pageY;
      const container = this.el.nativeElement;
      const containerBottom = container.offsetTop + container.offsetHeight;
      const containerTop = container.offsetTop;

      if (containerBottom - y < 120) {
        this._scrollDown(container, y);
      } else if (containerTop + y < 120) {
        this._scrollUp(container, y);
      }
    }
  }

  private _scrollDown(container: HTMLElement, pageY: number): void {
    if (this.drake.dragging && pageY === this._pageY) {
      container.scrollTop += 5;
      setTimeout(() => this._scrollDown(container, pageY), 20);
    }
  }

  private _scrollUp(container: HTMLElement, pageY: number): void {
    if (this.drake.dragging && pageY === this._pageY) {
      container.scrollTop -= 5;
      setTimeout(() => this._scrollUp(container, pageY), 20);
    }
  }
}
